import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchManyInputModule } from '../../base/fc-search-many-input/fc-search-many-input.module';
import { FcSegmentsInputComponent } from './fc-segments-input.component';


@NgModule({
  declarations: [
    FcSegmentsInputComponent
  ],
  imports: [
    FcSearchManyInputModule,
    TranslateModule
  ],
  exports: [
    FcSegmentsInputComponent
  ]
})
export class FcSegmentsInputModule {}
